export const reviews = [
  {
    id: 1,
    name: "Ana & Marko",
    tripKey: "barcelona",
    rating: 5,
    text_hr:
      "Savršeno organizirano putovanje, odličan vodič i puno slobodnog vremena za vlastito istraživanje.",
    text_en:
      "Perfectly organized trip, great guide and plenty of free time to explore.",
    text_de:
      "Perfekt organisierte Reise, toller Guide und viel Freizeit zum Entdecken.",
    text_es:
      "Viaje perfectamente organizado, excelente guía y mucho tiempo libre para explorar.",
  },
  {
    id: 2,
    name: "Petra",
    tripKey: "mexico",
    rating: 5,
    text_hr:
      "Meksiko je nadmašio sva očekivanja, a podrška agencije je stvarno bila 24/7.",
    text_en:
      "Mexico exceeded all expectations, and the agency support was truly 24/7.",
    text_de:
      "Mexiko hat alle Erwartungen übertroffen, der Agentursupport war wirklich 24/7.",
    text_es:
      "México superó todas las expectativas y el soporte de la agencia fue 24/7.",
  },
  {
    id: 3,
    name: "Lena",
    tripKey: "tuscany",
    rating: 4.8,
    text_hr:
      "Toskana je bila san – vinarije, sela, more… sve je bilo lagano i opušteno.",
    text_en:
      "Tuscany was a dream – wineries, villages, the sea… everything was relaxed.",
    text_de:
      "Die Toskana war ein Traum – Weingüter, Dörfer, Meer… alles sehr entspannt.",
    text_es:
      "La Toscana fue un sueño: bodegas, pueblos, mar… todo muy relajado.",
  },
];
